import { ApiInstance } from '../..';

export type TShop = {
    shopId: number;
    name: string;
    phone?: string;
    email?: string;
    address?: string;
    notes?: string;
    active?: boolean;
    createdAt?: string;
};

export type TShopPayload = {
    name: string;
    phone?: string;
    email?: string;
    address?: string;
    notes?: string;
    active?: boolean;
};

export const getShops = () =>
    ApiInstance.getInstance().get<TShop[]>('/api/shops');

export const getShopsForAssignment = () =>
    ApiInstance.getInstance().get<{ shopId: number; name: string }[]>(
        '/api/shops/assignment'
    );

export const createShop = (payload: TShopPayload) =>
    ApiInstance.getInstance().post('/api/shops/add', payload);

export const updateShop = (shopId: number, payload: TShopPayload) =>
    ApiInstance.getInstance().put(`/api/shops/${shopId}`, payload);

export const deleteShop = (shopId: number) =>
    ApiInstance.getInstance().delete(`/api/shops/${shopId}`);
